module.exports = __webpack_public_path__ + "img/in-stock.b5e8e6d.svg";